import type { MamBasketItem } from '@airpost/shared';

/**
 * The basket item ↑ or ↓ moves to from the one in the player, in the Video Hub's basket view: the next one whose
 * asset is still in the catalogue; the first (↓) or the last (↑) when none of the basket is loaded; the same one at
 * either end; null when no item can play.
 */
export function stepBasket(items: MamBasketItem[], currentId: string | null, step: 1 | -1): MamBasketItem | null {
  const at = currentId === null ? -1 : items.findIndex((i) => i.id === currentId);
  const live = (i: MamBasketItem | undefined) => !!i?.asset;
  if (at < 0) return (step > 0 ? items.find(live) : [...items].reverse().find(live)) ?? null;
  for (let k = at + step; k >= 0 && k < items.length; k += step) if (live(items[k])) return items[k]!;
  return live(items[at]) ? items[at]! : null;
}
